import { render, staticRenderFns } from "./TabHeading.vue?vue&type=template&id=3e3c53e8&scoped=true&lang=pug"
import script from "./TabHeading.vue?vue&type=script&lang=ts"
export * from "./TabHeading.vue?vue&type=script&lang=ts"
import style0 from "./TabHeading.vue?vue&type=style&index=0&id=3e3c53e8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3c53e8",
  null
  
)

export default component.exports